import Activate from './activate.vue'

export default {
  name: 'activate',
  path: '/accounts/activate/:token',
  component: Activate,
  meta: {
    secure: false,
    reCaptcha: true
  }
}